import { Text, View, Image, Svg, Path } from "@react-pdf/renderer";

import NoImage from "../../../../../Assets/missing_image.jpg";
import SummerIcon from "../../../../../Assets/summer.png";
import WinterIcon from "../../../../../Assets/winter-tyre.png";
import AllSeasonSummerIcon from "../../../../../Assets/summer-tyre.png";
const getEUColor = (rating) => {
  const colors = {
    a: "#008D3D",
    b: "#4EB43F",
    c: "#C3D52E",
    d: "#FFF100",
    e: "#FEB308",
    f: "#F58220",
    g: "#EE1C23",
  };

  return colors[rating?.toLowerCase()] || "#8e8e8e";
};

function ProductTag({ label }) {
  return (
    <Text
      style={{
        fontSize: 6,
        fontWeight: 700,
        border: "0.5px solid #777",
        borderRadius: 2,
        paddingHorizontal: 4,
        paddingVertical: 1,
        marginRight: 4,
        color: "#333",
      }}
    >
      {label}
    </Text>
  );
}


function FuelIcon() {
  return (
    <Svg width={11} height={11} viewBox="0 0 24 24">
      <Path
        fill="#1f1f1f"
        d="m19.77 7.23.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 0 0 2.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 0 0 5 0V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 .45 1 1 1-.45 1-1 1z"
      />
    </Svg>
  );
}

function WetGripIcon() {
  return (
    <Svg
      width={13}
      height={13}
      viewBox="0 0 512 512"
    >
      <Path
        fill="#1f1f1f"
        d="M456.26 139.37c-16.77-16.73-39.17-28.41-65.17-34a16 16 0 0 1-11.19-9 142.24 142.24 0 0 0-42.19-53.21C314.48 25.39 286.23 16 256 16a140.24 140.24 0 0 0-93.5 35.32c-24.2 21.56-40.91 51.34-48.43 85.83a16.05 16.05 0 0 1-11.72 12.18c-25 6.3-35.71 12.54-49.21 24.56C34 190.93 24 214.14 24 240.8c0 30.55 11.23 55.64 32.47 72.56C75.08 328.17 100.5 336 130 336h234c33.2 0 64.11-11.46 87-32.28 23.84-21.65 37-51.67 37-84.52 0-31.49-11-59.09-31.74-79.83zM112 448a16 16 0 0 1-13.3-24.88l32-48a16 16 0 0 1 26.62 17.76l-32 48A16 16 0 0 1 112 448zm48 48a16 16 0 0 1-13.29-24.88l64-96a16 16 0 0 1 26.62 17.76l-64 96A16 16 0 0 1 160 496zm112-48a16 16 0 0 1-13.3-24.88l32-48a16 16 0 0 1 26.62 17.76l-32 48A16 16 0 0 1 272 448zm48 48a16 16 0 0 1-13.3-24.88l64-96a16 16 0 0 1 26.62 17.76l-64 96A16 16 0 0 1 320 496z"
      />
    </Svg>
  );
}

function NoiseIcon() {
  return (
    <Svg
      width={12}
      height={12}
      viewBox="0 0 512 512"
    >
      <Path
        fill="#1f1f1f"
        d="M297.87 24.322c-40.38.374-80.665 13.623-114.077 39.72 73.64-37.01 166.104-24.977 227.547 36.464 61.442 61.44 73.013 153.443 36.002 227.084 57.598-73.738 53.068-180.48-14.77-248.317-37.098-37.098-85.97-55.4-134.703-54.95zm-27.25 63.123c-37.16.42-74.186 14.305-102.975 41.67 60.11-36.405 139.642-28.35 191.54 23.545 51.897 51.898 59.488 130.976 23.08 191.086 56.502-59.44 56.012-153.534-2.31-211.855C349.883 101.82 310.177 87 270.62 87.446zm-16.61 59.54c-28.304 0-56.606 10.797-78.2 32.392-43.19 43.19-43.19 113.214 0 156.404 43.188 43.19 113.21 43.19 156.4 0 43.19-43.19 43.19-113.213 0-156.403-21.594-21.595-49.897-32.393-78.2-32.393zm-132.635 28.4c-56.503 59.44-55.552 153.995 2.77 212.316 58.32 58.323 152.416 58.81 211.855 2.308-60.112 36.41-139.186 28.822-191.084-23.078-51.898-51.9-59.95-131.435-23.54-191.545zM56.297 191.54C-1.3 265.276 3.69 372.48 71.527 440.317c67.838 67.838 174.58 72.366 248.32 14.77-73.642 37.01-165.647 25.44-227.087-36.002-61.44-61.442-73.474-153.908-36.463-227.547z"
      />
    </Svg>
  );
}

export default function DocumentProducts({ order, products }) {
  const hasDiscount = order?.discountPrice > 0;

  return (
    <View>
      <View
        style={{
          flexDirection: "row",
          flexWrap: "nowrap",
          backgroundColor: "#111318",
          color: "#ffffff",
          paddingVertical: 4,
          paddingHorizontal: 4,
          fontSize: 9,
        }}
      >
        <Text style={{ flex: 0.12 }}>Nr.</Text>

{/* Column for picture */}
<Text style={{ flex: 0.58 }} />

<Text style={{ flex: 1.25, fontWeight: 600 }}>
  Apraksts
</Text>

        <Text style={{ flex: 0.7, textAlign: "center" }}>
          Daudzums
        </Text>

        {hasDiscount && (
          <Text style={{ flex: 0.6, textAlign: "center" }}>
            Atlaide
          </Text>
        )}

        <Text style={{ flex: 1.05 }}>
          Cena
        </Text>

        <Text style={{ flex: 1.05 }}>
          Kopējā cena
        </Text>
      </View>

      {products.map((product, index) => {
        const tire = product.product;

        const productTypes = {
          tire: `${tire.width || "-"} / ${tire.height || "-"} R${
          parseInt(tire.diameter) || "-"
                }${tire.isCTire ? "C" : ""} ${
                  tire.loadIndex || ""
                }${tire.speedRating?.toUpperCase() || ""}`,
          rim: `${tire.width || "-"}J | R${parseInt(tire.diameter) || "-"} | ${
            tire.pitchCircleDiameter || "-"
          } | ET${tire.offset || "-"} | CB${tire.centreBore || "-"}`,
          battery: `${tire.voltage || "-"} V | ${tire.current || "-"} A | ${
            tire.capacity || "-"
          } Ah`,
        };

        const priceWithoutVat = (Number(product.price) / 1.21).toFixed(2);
        const totalWithoutVat = (
          (Number(product.price) / 1.21) * Number(product.count)
        ).toFixed(2);
        const totalWithVat = (
          Number(product.price) * Number(product.count)
        ).toFixed(2);

        return (
          <View
            key={product.id}
            wrap={false}
            style={{
              flexDirection: "row",
              flexWrap: "nowrap",
              borderBottom: "0.5px solid #c7c7c7",
              minHeight: 82,
              paddingVertical: 4,
              paddingHorizontal: 4,
            }}
          >
            {/* Nr */}
            <View
              style={{
                flex: 0.12,
                justifyContent: "center",
              }}
            >
              <Text style={{ fontSize: 9 }}>
                {index + 1}
              </Text>
            </View>

{/* Foto */}
<View
  style={{
    flex: 0.58,
    justifyContent: "center",
    alignItems: "center",
  }}
>
  <Image
  src={ ( typeof tire?.currentImage === "string" && tire.currentImage.startsWith ( "data:" ) )
      ? tire.currentImage
      : NoImage }
  style={{
    width: 68,
    height: 68,
    objectFit: "contain",
  }}
/>
</View>

{/* Description */}
<View
  style={{
    flex: 1.25,
    justifyContent: "center",
    paddingRight: 6,
  }}
>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: 700,
                }}
              >
                {[tire?.manufacturer?.name, tire?.model]
                  .filter(Boolean)
                  .join(" ")
                  .toUpperCase()}
              </Text>

              <Text
                style={{
                  fontSize: 8,
                  marginTop: 2,
                }}
              >
                {tire.productType === "tire"
                  ? `${productTypes.tire}${
                      tire.year ? ` | DOT: ${tire.year}` : ""
                    }`
                  : productTypes[tire.productType]}
              </Text>
              <Text
  style={{
    fontSize: 7,
    color: "#8e8e8e",
    marginTop: 2,
  }}
>
  ID: {tire?.id || product?.productId || "-"}
</Text>

              {/* XL / RFT / STUD un tt */}
              <View
                style={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  marginTop: 3,
                }}
              >
                {tire.xl && <ProductTag label="XL" />}

                {tire.runFlat && <ProductTag label="RFT" />}

                {tire.studs === "yes" && <ProductTag label="STUD" />}

                {tire.studs === "possible" && (
                  <ProductTag label="STUD+" />
                )}

                {tire.seal && <ProductTag label="SEAL" />}

                {tire.demo && <ProductTag label="DEMO" />}

                {tire.model === "POLARMAXX SPORT" && (
                  <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                    <ProductTag label="REINF" />
                    <ProductTag label="RFT" />
                    <ProductTag label="SEAL INSIDE" />
                    <ProductTag label="EV READY" />
                    <ProductTag label="MO" />
                    <ProductTag label="3PMSF" />
                    <ProductTag label="M+S" />
                    <ProductTag label="TL" />
                    <ProductTag label="CONTISILENT" />
                    <ProductTag label="FR" />
                    <ProductTag label="OWL" />
                  </View>
                )}

              </View>

              {/* EU marķejums */}
              {tire.productType === "tire" && (
  <View
    style={{
      flexDirection: "row",
      alignItems: "center",
      marginTop: 4,
    }}
  >
    {tire.fuelEfficiency && (
  <View
    style={{
      flexDirection: "row",
      alignItems: "center",
      marginRight: 8,
      height: 14,
    }}
  >
    <View
      style={{
        width: 12,
        height: 14,
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: 1,
      }}
    >
      <FuelIcon />
    </View>

    <View
      style={{
        width: 14,
        height: 14,
        marginLeft: 3,
        backgroundColor: getEUColor(tire.fuelEfficiency),
        borderRadius: 1,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Text
        style={{
          fontSize: 7,
          fontWeight: 700,
          color: "#111111",
        }}
      >
        {tire.fuelEfficiency.toUpperCase()}
      </Text>
    </View>
  </View>
)}

    {tire.wetBreakingEfficiency && (
  <View
    style={{
      flexDirection: "row",
      alignItems: "center",
      marginRight: 8,
      height: 14,
    }}
  >
    <View
      style={{
        width: 13,
        height: 14,
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: 1,
      }}
    >
      <WetGripIcon />
    </View>

    <View
      style={{
        width: 14,
        height: 14,
        marginLeft: 3,
        backgroundColor: getEUColor(tire.wetBreakingEfficiency),
        borderRadius: 1,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Text
        style={{
          fontSize: 7,
          fontWeight: 700,
          color: "#111111",
        }}
      >
        {tire.wetBreakingEfficiency.toUpperCase()}
      </Text>
    </View>
  </View>
)}

    {tire.noiseIndex && (
  <View
    style={{
      flexDirection: "row",
      alignItems: "center",
      height: 14,
      marginRight: 8,
    }}
  >
    <View
      style={{
        width: 12,
        height: 14,
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: 1,
      }}
    >
      <NoiseIcon />
    </View>

    <Text
      style={{
        marginLeft: 2,
        fontSize: 8,
        fontWeight: 600,
        color: "#222",
      }}
    >
      {tire.noiseIndex} dB
    </Text>
  </View>
)}

    {tire.season === "s" && (
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Image
          src={SummerIcon}
          style={{
            width: 13,
            height: 13,
            objectFit: "contain",
          }}
        />

        <Text
          style={{
            marginLeft: 3,
            fontSize: 8,
            fontWeight: 600,
            color: "#222",
          }}
        >
          Vasaras riepa
        </Text>
      </View>
    )}

    {tire.season === "w" && (
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Image
          src={WinterIcon}
          style={{
            width: 13,
            height: 13,
            objectFit: "contain",
          }}
        />

        <Text
          style={{
            marginLeft: 3,
            fontSize: 8,
            fontWeight: 600,
            color: "#222",
          }}
        >
          Ziemas riepa
        </Text>
      </View>
    )}

    {tire.season === "ms" && (
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Image
          src={AllSeasonSummerIcon}
          style={{
            width: 12,
            height: 12,
            objectFit: "contain",
          }}
        />

        <Image
          src={WinterIcon}
          style={{
            width: 12,
            height: 12,
            objectFit: "contain",
            marginLeft: 2,
          }}
        />

        <Text
          style={{
            marginLeft: 3,
            fontSize: 8,
            fontWeight: 600,
            color: "#222",
          }}
        >
          Vissezonas riepa
        </Text>
      </View>
    )}
  </View>
)}
</View>


            {/* Daudzums */}
            <View
              style={{
                flex: 0.7,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text style={{ fontSize: 9 }}>
                {product.count}
              </Text>
            </View>

            {/* Atlaide */}
            {hasDiscount && (
              <View
                style={{
                  flex: 0.6,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Text style={{ fontSize: 9 }}>
                  {Number(product.discount) > 0 ? `${product.discount} %` : ""}
                </Text>
              </View>
            )}

            {/* Cena par gab. */}
            <View
              style={{
                flex: 1.05,
                justifyContent: "center",
              }}
            >
              <Text style={{ fontSize: 8 }}>
                bez PVN: {priceWithoutVat} EUR
              </Text>

              {order?.vatIncluded && (
                <Text
                  style={{
                    fontSize: 8,
                    marginTop: 3,
                  }}
                >
                  ar PVN: {Number(product.price).toFixed(2)} EUR
                </Text>
              )}
            </View>

            {/* Kop.sum. */}
            <View
              style={{
                flex: 1.05,
                justifyContent: "center",
              }}
            >
              <Text style={{ fontSize: 8 }}>
                bez PVN: {totalWithoutVat} EUR
              </Text>

              {order?.vatIncluded && (
                <Text
                  style={{
                    fontSize: 8,
                    marginTop: 3,
                  }}
                >
                  ar PVN: {totalWithVat} EUR
                </Text>
              )}
            </View>
          </View>
        );
      })}

{!order?.hideTotalsInPdf && (
      <View
        style={{
          flexDirection: "row",
          alignSelf: "flex-end",
          fontSize: 10,
          marginTop: 8,
        }}
      >
        <View style={{ width: "50%" }}>
          {hasDiscount && (
            <View style={{ flexDirection: "row" }}>
              <Text style={{ flex: 1 }}>
                Atlaide
              </Text>

              <Text style={{ flex: 1 }}>
                {Number(order.discountPrice).toFixed(2)} EUR
              </Text>
            </View>
          )}

          <View style={{ flexDirection: "row" }}>
            <Text style={{ flex: 1 }}>
              Montāža
            </Text>

            <Text style={{ flex: 1 }}>
              {Number(order.assemblyPrice || 0).toFixed(2)} EUR
            </Text>
          </View>

          <View
            style={{
              flexDirection: "row",
              borderBottom: "1px solid #999",
            }}
          >
            <Text style={{ flex: 1 }}>
              Piegāde
            </Text>

            <Text style={{ flex: 1 }}>
              {Number(order.deliveryPrice || 0).toFixed(2)} EUR
            </Text>
          </View>

          <View style={{ flexDirection: "row" }}>
            <Text style={{ flex: 1 }}>
              Kopsumma bez PVN
            </Text>

            <Text style={{ flex: 1 }}>
              {(Number(order.price) / 1.21).toFixed(2)} EUR
            </Text>
          </View>

          <View style={{ flexDirection: "row" }}>
            <Text style={{ flex: 1 }}>
              PVN
            </Text>

            <Text style={{ flex: 1 }}>
              {order?.vatIncluded
                ? (
                    Number(order.price) -
                    Number(order.price) / 1.21
                  ).toFixed(2)
                : "0.00"}{" "}
              EUR
            </Text>
          </View>

          <View
            style={{
              flexDirection: "row",
              borderBottom: "1px solid #999",
              borderTop: "1px solid #999",
              fontWeight: 700,
              fontSize: 11,
            }}
          >
            <Text style={{ flex: 1 }}>
              Kopsumma apmaksai
            </Text>

            <Text style={{ flex: 1 }}>
              {order?.vatIncluded
                ? Number(order.price).toFixed(2)
                : (Number(order.price) / 1.21).toFixed(2)}{" "}
              EUR
            </Text>
          </View>
        </View>
      </View>
      )}
    </View>
  );
  
}
